import React from 'react'
import { useHelpBotContext, POSITIONS } from '../../context/HelpBotContext'
import { HelpBotFab } from './components/HelpBotFab/HelpBotFab'
import { HelpBotPanel } from './components/HelpBotPanel/HelpBotPanel'
import { HelpBotNudge } from './components/HelpBotNudge/HelpBotNudge'
import { useHelpBotNudge } from './hooks/useHelpBotNudge'
import styles from './HelpBot.module.scss'

export const HelpBot = () => {
    const {
        isOpen,
        messages,
        hasUnread,
        panelSize,
        position,
        isPending,
        toggleChat,
        closeChat,
        clearMessages,
        markAsRead,
        changePanelSize,
        changePosition,
        sendPrompt,
    } = useHelpBotContext()

    const { isVisible, nudgeConfig, dismiss, dismissForever } = useHelpBotNudge({
        isHelpBotOpen: isOpen,
    })

    const containerClassName = [styles.container, position === POSITIONS.LEFT && styles.left]
        .filter(Boolean)
        .join(' ')

    return (
        <div className={containerClassName}>
            <HelpBotPanel
                isOpen={isOpen}
                messages={messages}
                isPending={isPending}
                hasUnread={hasUnread}
                panelSize={panelSize}
                position={position}
                onClose={closeChat}
                onClearChat={clearMessages}
                onSendMessage={sendPrompt}
                onMarkAsRead={markAsRead}
                onChangePanelSize={changePanelSize}
                onChangePosition={changePosition}
            />
            <HelpBotNudge
                isVisible={isVisible}
                config={nudgeConfig}
                onDismiss={dismiss}
                onDismissForever={dismissForever}
                position={position}
            />
            <HelpBotFab
                isOpen={isOpen}
                hasUnread={hasUnread}
                isPending={isPending}
                onClick={toggleChat}
            />
        </div>
    )
}
